/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Review_Category_StructureInputs */

const en_cv_review_category_structure = /** @type {(inputs: Cv_Review_Category_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structural Improvements`)
};

const de_cv_review_category_structure = /** @type {(inputs: Cv_Review_Category_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturelle Verbesserungen`)
};

/**
* | output |
* | --- |
* | "Structural Improvements" |
*
* @param {Cv_Review_Category_StructureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_review_category_structure = /** @type {((inputs?: Cv_Review_Category_StructureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Review_Category_StructureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_review_category_structure(inputs)
	return en_cv_review_category_structure(inputs)
});